import {Map, List} from 'immutable';

export type BindingPathMap = Map<string, ShallowBindingPath | DeepBindingPath>;
export type ShallowBindingPath = List<Map<string, string>>;
export type DeepBindingPath = Map<string, ShallowBindingPath>;

export type BindingPathMapPojo = Record<
  string,
  ShallowBindingPathPojo | DeepBindingPathPojo
>;
export type ShallowBindingPathPojo = Array<Record<string, string>>;
export type DeepBindingPathPojo = Record<string, ShallowBindingPathPojo>;

export type BindingTransformer = {
  type: string;
  params: string[];
};

export function isDeepBindingPath(
  bindingPath: ShallowBindingPath | DeepBindingPath
): bindingPath is DeepBindingPath {
  return bindingPath instanceof Map;
}

export function isShallowBindingPath(
  bindingPath: ShallowBindingPath | DeepBindingPath
): bindingPath is ShallowBindingPath {
  return bindingPath instanceof List;
}

export function isDeepBindingPathPojo(
  desc: ShallowBindingPathPojo | DeepBindingPathPojo
): desc is DeepBindingPathPojo {
  return typeof desc === 'object' && desc !== null && !Array.isArray(desc);
}

export function isShallowBindingPathPojo(
  desc: ShallowBindingPathPojo | DeepBindingPathPojo
): desc is ShallowBindingPathPojo {
  return Array.isArray(desc);
}
